var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTaskMp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9938 14.4449L31.2193 21.5969C31.4242 27.7709 29.3816 30.8374 24.2294 31.7003C23.4072 31.8516 22.499 31.9396 21.5049 31.9645L18.6278 32.0452C11.4875 32.2502 8.52216 29.4903 8.29674 22.3383L8.067 15.1702C8.02231 13.7155 8.08947 12.4207 8.3093 11.3092C9.14895 6.90864 12.0722 5.00381 17.79 4.83485L20.6467 4.74232C27.8148 4.51258 30.7684 7.29288 30.9938 14.4449Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 24.551C18.5028 23.8347 18.1856 23.165 17.6749 22.6581C17.1643 22.1511 16.4923 21.8389 15.7755 21.7755C15.2598 21.7244 14.7403 21.7244 14.2245 21.7755C13.5084 21.8408 12.8375 22.1537 12.3273 22.6602C11.817 23.1668 11.4992 23.8354 11.4286 24.551M15 19.4081C15.4899 19.4081 15.9596 19.2135 16.306 18.8672C16.6524 18.5208 16.847 18.051 16.847 17.5612C16.847 17.0713 16.6524 16.6016 16.306 16.2552C15.9596 15.9088 15.4899 15.7142 15 15.7142C14.5102 15.7142 14.0404 15.9088 13.694 16.2552C13.3477 16.6016 13.1531 17.0713 13.1531 17.5612C13.1531 18.051 13.3477 18.5208 13.694 18.8672C14.0404 19.2135 14.5102 19.4081 15 19.4081Z",
    stroke: "#595959",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.4286H27.1429M21.4286 17.1429H27.1429M24.2857 22.8572H27.1429",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTaskMp);
export default __webpack_public_path__ + "static/media/MyTaskMP.90736715062639d9eec4b27e34bc6301.svg";
export { ForwardRef as ReactComponent };